module.exports = __webpack_public_path__ + "media/images/lb/158-2bb53872ee0ead7ac45cd723e4c3b9c4.svg";